export default function CookiesPolicyPage() {
  return (
    <div className="container -legalPages main">
      <div className="row">
        <div className="col-md-12 offset-md-1 pt-5">
          <div className="row d-flex header-container">
            <h2>
              Cookies Policy
            </h2>
          </div>
          <br/>
          <div className="row d-flex">
            <p>
              Our website uses cookies to distinguish you from other users of our website. A cookie is a small file
              of letters and numbers that we put on your computer if you agree. This helps us to provide you with a
              good experience when you browse our website and also allows us to improve our site.
            </p>
            <p>
              We use the following 4 main types of cookies:
            </p>
          </div>
          <div className="row d-flex">
            <h3>Strictly necessary cookies:</h3>
            <p>
              These are cookies that are required for the operation of our website. They include, for example,
              cookies that enable you to log into secure areas of our website and enter into transactions.
            </p>
          </div>
          <div className="row d-flex">
            <h3>Analytical / Performance cookies:</h3>
            <p>
              They allow us to recognise and count the number of visitors and to see how visitors move around our
              website when they are using it. This helps us to improve the way our website works, for example, by
              ensuring that users are finding what they are looking for easily.
            </p>
          </div>
          <div className="row d-flex">
            <h3>Functionality cookies:</h3>
            <p>
              These are used to recognise you when you return to our website. This enables us to personalise our
              content for you, greet you by name and remember your preferences (for example, your choice of language
              or region).
            </p>
          </div>
          <div className="row d-flex">
            <h3>Targeting cookies:</h3>
            <p>
              These cookies record your visit to our website, the pages you have visited and the links you have
              followed. We will use this information to make our website and the advertising displayed on it more
              relevant to your interests. We may also share this information with third parties for this purpose.
            </p>
            <p>
              If you wish you can change your cookie settings in your browser if you would like to prevent any
              cookies being stored on your online enabled device, but be aware that this may severely impact the
              functionality of the site.
            </p>
            <div className="row d-flex">
              <p>
                Please note that third parties (including, for example, advertising networks and providers of
                external services like web traffic analysis services) may also use cookies, over which we have no
                control. These cookies are likely to be analytical/performance cookies or targeting cookies.
              </p>
            </div>
            <div className="row d-flex">
              <p>
                You can block cookies by activating the setting on your browser that allows you to refuse the
                setting of all or some cookies. However, if you use your browser settings to block all cookies
                (including essential cookies) you may not be able to access all or parts of our site.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
